<template>
	<div id="scorecard">
		<h1>
			<i class="fad fa-poll fa-fw"></i> 
			Scorecard (Tier 2)
		</h1>
		<div v-if="isLoading"><i class="fad fa-spinner-third fa-spin fa-2x"></i></div>
		<div v-else id="candidate-container" class="rec-container">
			<router-link v-bind:to="'/admin/scorecard-2/card/' + candidate.user" class="rec" v-for="candidate in candidatesList" v-bind:key="candidate.id">
				<div>
					<span>{{candidate.nameFirst}} {{candidate.nameLast}}</span> 
				</div>
			</router-link>
		</div>
	</div>
</template>
<script>
export default {
	data() {
		return {
			isLoading: false,
		}
	},
	computed: {
		candidatesList(){
			return this.$store.getters.candidatesAll
		}
	},
	methods: {
		async loadScorecard(id) {
			this.isLoading = true
			await this.$store.dispatch('loadScorecard',id)
			setTimeout(()=>{ 
				this.isLoading = false
			},150)
		},
		async loadScorecards(){
			this.isLoading = true
			await this.$store.dispatch('allScoreCards')
			setTimeout(()=>{ 
				this.isLoading = false
			},150)
		}
	},
	async created(){
		if( this.candidatesList.length <= 1){
			await this.$store.dispatch('loadApplicants')
			if(this.$store.getters.loggedInUser.role === 'admin'){
				await this.loadScorecards()
			} else {
				await this.loadScorecard(this.$store.getters.loggedInUser.uid)
			}
		}
	}
}
</script>
<style scoped>
:root {
	--ar-purple: #483751;
}
</style>